export default "__VITE_ASSET__4622c861__"